<template>
  <div class="book">
    <drag-modal :visible="$store.state.dislog.Book" @cancel="close" title='裁判文书' width='840px'>
      <FileSee ref='FileSee' :info='info'></FileSee>
      <div class="table">
        <table>
          <thead>
            <td width="30">序号</td>
            <td width="80">进度</td>
            <td width='200'>文件名</td>
            <td width='40'>操作</td>
          </thead>
          <tbody>
            <tr v-for='(i, index) in list' :key="index">
              <td>{{ (index + 1) + 10 * (form.page - 1) }}</td>
              <td>{{ stepType(i.step) }}</td>
              <td> {{ i.title }} </td>
              <td style="white-space: nowrap;">
                <a href='javascript:void(0);' class="see" @click='see(i.upload)'>查看</a>
              </td>
            </tr>
          </tbody>
        </table>
        <a-empty v-if='list.length == 0' style="margin:20px 0;" />
      </div>
      <div class="pages" v-if='total > 10'>
        <a-pagination :total="total" show-less-items show-quick-jumper @change="turnpage" />
      </div>
    </drag-modal>
  </div>
</template>
<script>
import { shareFile } from '@/server/debtor'
import FileSee from "@/components/filesee"
import { Filetype } from "@/assets/js/unit"
import liteKey from '@/page/ly/liteKey'
export default {
  props: {
    id: Number
  },
  components: { FileSee },
  data() {
    return {
      info: {},
      total: 0,
      form: {
        page: 1,
        limit: 10
      },
      list: [],
    }
  },
  computed: {
    imgList() {
      if (this.list) {
        let fileList = JSON.parse(JSON.stringify(this.list))
        fileList.map((ele, index) => {
          ele.index = index
        })
        return fileList.filter(ele => {
          return Filetype(ele.url) == 3
        })
      } else {
        return []
      }
    }
  },
  methods: {
    stepType(step) {
      return liteKey[step]
    },
    Filetype,
    turnpage(val) {
      this.form.page = val
      this.getList()
    },
    see(i) {
      if (Filetype(i.show_url) == 4) {
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + i.show_url)
      } else {
        this.info = {
          type: Filetype(i.show_url),
          url: i.show_url,
          title: i.origin_name
        }
        this.$refs.FileSee.visible = true;
      }
    },
    getList() {
      shareFile(Object.assign({ cause_id: this.id }, this.form)).then(e => {
        this.list = e.list;
        this.total = e.count
      })
    },
    close() {
      this.form.page = 1;
      this.$store.dispatch('openkey', { key: 'Book', by: false })
    },
  },
  created() {
    this.getList()
  }
}
</script>
<style lang="less" scoped>
.see {
  position: relative;
  display: inline-block;

  .pimg {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .fir {
    z-index: 999;
  }

  img {
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
}
</style>